export default function Selector(state, property) {
  const selectors = {
    orders: (s) => s.orders?.list || [],
  };
  return selectors[property](state);
}
